import Ajax from './Ajax.js'

const Stats = {
  getStats: () => {
    return Ajax.get('/stats');
  },
  getTheoreticalStats: () => {
    return Ajax.get('/theoretical-stats');
  },
  getAdminStats: () => {
    return Ajax.get('/admin-stats');
  },
  getBuffer: () => {
    return Ajax.get('/buffer');
  },
  // Platform-wide Statistics page — all read-only aggregation endpoints,
  // see new-server/src/api/stats/controllers/stats.js
  getOverview: () => {
    return Ajax.get('/stats/overview');
  },
  getCo2Trend: () => {
    return Ajax.get('/stats/co2-trend');
  },
  getByCountry: () => {
    return Ajax.get('/stats/by-country');
  },
  getByTreeType: () => {
    return Ajax.get('/stats/by-tree-type');
  },
  getTopForests: (limit = 10) => {
    return Ajax.get(`/stats/top-forests?limit=${limit}`);
  },
  getTokenFlow: () => {
    return Ajax.get('/stats/token-flow');
  },
  getCustomersTrend: () => {
    return Ajax.get('/stats/customers-trend');
  },
  getLive: () => {
    return Ajax.get('/stats/live');
  },
  // administrators only: map, forecast, monthly activity, tree stock, growth and scan calendar
  getInsights: () => {
    return Ajax.get('/stats/insights');
  },
  // the signed-in user's own forests and wallet (home dashboard of non-administrators)
  getMine: () => {
    return Ajax.get('/stats/me');
  },
  // the caller's own layout of a page: 'statistics' (administrators) or 'home' (null until they customise it)
  getLayout: (page = 'statistics') => {
    return Ajax.get(`/stats/layout?page=${page}`);
  },
  saveLayout: (layout, page = 'statistics') => {
    return Ajax.put(`/stats/layout?page=${page}`, { layout });
  }
}

export default Stats
